module.exports = __webpack_public_path__ + "img/busy-loader.f2a866c5.svg";